import React, { Component } from 'react';
import { Route, withRouter } from "react-router-dom";
import SimplePopover from '../SimplePopover';
import Loading from '../Loading';

import AdaptativaHeader from '../AdaptativaHeader';
import Acompanhamento from './acompanhamento/Acompanhamento';
import BibliotecaConteudo from '../shared/conteudo/BibliotecaConteudo';

import TrilhaConteudo from './trilha/TrilhaConteudo';
import * as SimuladoRequest from '../../requests/simulado.request';
import * as GamificacaoRequest from '../../requests/gamificacao.request';
import * as AcompanhamentoRequest from '../../requests/acompanhamento.request';

class AlunoPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadingGeral: false,
            existSimulado: false,
            userPoints: null,
            simuladoAtual: ''
        }

    }

    async componentDidMount() {

        //Exibindo o loading
        this.setState({ loadingGeral: true });

        // Atualiza situacao do simulado
        await SimuladoRequest.setSituacaoSimulado();

        this.getPts()

        //Buscando se existe simulado realizado para o aluno
        var existSimulado = await SimuladoRequest.getStatusSimuladoAluno();

        //Define se existe simulado e finaliza o loading
        this.setState({ loadingGeral: false, existSimulado: existSimulado });

    }

    async getPts() {
        try{


            // Atualiza notas TRI do aluno
            await SimuladoRequest.setNotasTri();

            //Buscando as médias por disciplina
            var notasTRI = await AcompanhamentoRequest.getNotasTRI();
            // console.log('notasTRI', notasTRI)

            // var ptsUsr = await GamificacaoRequest.getPontuacaoUsuario();
            var ptsUsr = await GamificacaoRequest.getNovaPontuacaoUsuario();
            // console.log('pontos ptsUsr', ptsUsr)
            ptsUsr = ptsUsr || 0;
            var txPracticeTest = notasTRI && notasTRI.length>0 && notasTRI[0].txPracticeTest
            // console.log('txPracticeTest',txPracticeTest)

             // console.log('pontos ptsUsr', ptsUsr)
            this.setState({ userPoints: ptsUsr, mediaTRI: this.getMediaTRI(notasTRI), notasTRI: notasTRI, simuladoAtual: txPracticeTest });

        }catch(e){
            console.log(e)
        }
    }

    getMediaTRI(medias) {

        return (medias.reduce((partial_sum, a) => (partial_sum + a.nuScoreTRI), 0) / medias.length).toFixed(2);
    }

    getActiveTab(defaultRoute) {
        var path = (defaultRoute || this.props.location.pathname).toLowerCase();

        if (path === "/app/trilha") { return { title: "Trilhas do Conhecimento", backgroundClassName: " adap-green ", borderClassName: " adap-border-green " }; }
        if (this.state.existSimulado && path === "/app/acompanhamento") { return { title: "Acompanhamento", backgroundClassName: " adap-yellow ", borderClassName: " adap-border-yellow " }; }
        if (path === "/app/biblioteca") { return { title: "Biblioteca de Conteúdo", backgroundClassName: " adap-blue ", borderClassName: "  adap-border-blue " }; }

        //Se não está em nenhuma das rotas anteriores, retorna a aba padrão
        return this.getActiveTab("/app/trilha");
    }

    render() {
        return (
            <div >
                <AdaptativaHeader />

                {this.state.loadingGeral && <Loading />}

                {!this.state.loadingGeral && <span>

                    {/* Navegação das Abas Dektop */}
                    <div className={"edb-hide-small edb-hide-medium edb-margin-top edb-bottombar-small " + this.getActiveTab().borderClassName}>
                        <a className="edb-btn adap-green" href="#/app/trilha">Trilhas do Conhecimento</a>
                        {!this.state.existSimulado && <button className="edb-btn adap-yellow edb-lock" href="#/app/acompanhamento ">Acompanhamento</button>}
                        {this.state.existSimulado && <a className="edb-btn adap-yellow" href="#/app/acompanhamento">Acompanhamento</a>}
                        <a className="edb-btn adap-blue edb-lock2" href="#/app/biblioteca">Biblioteca de Conteúdo</a>
                        <a className="edb-right edb-padding" title="Acesso à wiki.Adaptativa+" target="_blank" rel="noopener noreferrer" href={process.env.REACT_APP_WIKI+'/a/'}><i className="edb-xlarge fas fa-question-circle"></i></a>
                    </div>

                    {/* Navegação das Abas Mobile */}
                    <div className={"edb-hide-large edb-hide-large edb-center " + this.getActiveTab().backgroundClassName}>

                        <SimplePopover noPadding={true} content={<div className="edb-bar-block" style={{ width: "300px" }}>
                            <a className="edb-bar-item edb-button edb-medium " href="#/app/trilha">Trilhas do Conhecimento</a>
                            {!this.state.existSimulado && <button className="edb-bar-item edb-button edb-medium edb-lock" href="#/app/acompanhamento">Acompanhamento</button>}
                            {this.state.existSimulado && <a className="edb-bar-item edb-button edb-medium " href="#/app/acompanhamento">Acompanhamento</a>}
                            <a className="edb-bar-item edb-button edb-medium edb-lock2" href="#/app/biblioteca">Biblioteca de Conteúdo</a>
                            <a className="edb-bar-item edb-button edb-medium" target="_blank" rel="noopener noreferrer" href={process.env.REACT_APP_WIKI+'/a/'}>wiki.Adaptativa+</a>
                        </div>}>
                            <div className="edb-btn" style={{ width: "300px" }}>
                                <span className="edb-large edb-text-bold adap-text-white">{this.getActiveTab().title}</span>
                                <i className="fas fa-chevron-down edb-margin-left adap-text-white"></i>
                            </div>
                        </SimplePopover>
                    </div>

                    {this.state.userPoints !== null && <div className="edb-col l2 edb-padding edb-right edb-margin-points " >
                        <div className="edb-row-cell">
                            <div className="edb-cell">
                                <div className="edb-tiny">NOTA TRI</div>
                                <div className="edb-text-bold edb-large">{this.state.mediaTRI}</div>
                            </div>
                            <div className="edb-cell edb-padding-left">
                                <div className="edb-tiny">PONTOS</div>
                                <div className="edb-text-bold edb-large">{this.state.userPoints}</div>
                            </div>
                        </div>
                    </div>}

                    <div className="adap-mobile-container">


                        {/* Aba padrão */}
                        <Route exact path="/app" component={TrilhaConteudo} />


                        {/* Abas */}
                        <Route path="/app/trilha" component={TrilhaConteudo} />

                        <Route path="/app/acompanhamento" render={(props) => <Acompanhamento {...props} simuladoAtual={this.state.simuladoAtual} mediaTRI={this.state.mediaTRI} notasTRI={this.state.notasTRI} />} />
                        <Route path="/app/biblioteca" component={BibliotecaConteudo} />

                    </div>
                </span>}
            </div>
        );
    }
}

export default withRouter(props => <AlunoPage {...props} />);
